export default __webpack_public_path__ + "static/media/img-0277-malta-full-face.8b541ab2.png";